import Stack from '@mui/material/Stack';
import { border } from '../utils/theme.js';
import Typography from '@mui/material/Typography';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import BrandedCertificateImage from '@pok/weblib/ui/BrandedCertificateImage.jsx';
import { certificatesFor, gatewayUrl } from '../interact.jsx';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function RelatedCredentials({ certificate }) {
    const { t } = useTranslation();
    const [related, setRelated] = useState(undefined);
    useEffect(() => {
        if (certificate.userId !== 'unavailable') {
            certificatesFor(certificate.userId).then((res) =>
                setRelated(res.certificates.filter((x) => x.id !== certificate.id).slice(0, 5)),
            );
        } else {
            setRelated([]);
        }
    }, [certificate]);
    return (
        <>
            {related === undefined && <></>}
            {related !== undefined && (
                <Box
                    sx={{
                        ...border,
                        borderRadius: 4,
                        paddingX: 2,
                        paddingY: { xs: 1, md: 2 },
                    }}
                >
                    <Stack>
                        {related.length === 0 && (
                            <Grid container sx={{ alignItems: 'center', mb: 1 }}>
                                <Grid item xs={12} sm={9}>
                                    <Typography variant="subtitle1">{t('certificates.more_credentials')}</Typography>

                                    <Typography variant="body11">
                                        {t('certificates.related_credentials_empty')}
                                    </Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={3}
                                    sx={{ textAlign: { xs: 'start', sm: 'end' }, mt: { xs: 2, sm: 0 } }}
                                >
                                    <a href={import.meta.env.VITE_HOLDER_ROOT} target={'_blank'}>
                                        <Button variant="contained" sx={{ p: 1.5, borderRadius: 2 }}>
                                            {t('certificates.log_in')}
                                        </Button>
                                    </a>
                                </Grid>
                            </Grid>
                        )}
                        {related.length > 0 && (
                            <>
                                <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    justifyContent={'space-between'}
                                    spacing={1}
                                    sx={{ alignItems: { xs: 'start', sm: 'center' } }}
                                >
                                    <Typography variant="subtitle1">{t('certificates.more_credentials')}</Typography>
                                    <Link to={`/l/${certificate.userId}/public`} style={{ textDecoration: 'none' }}>
                                        <Typography variant="link" fontSize={12}>
                                            {t('certificates.see_all')}
                                        </Typography>
                                    </Link>
                                </Stack>
                                <Grid
                                    container
                                    sx={{
                                        mt: 2,
                                        overflowX: 'auto',
                                        flexWrap: 'nowrap',
                                    }}
                                >
                                    {related.map((item, index) => (
                                        <Grid
                                            item
                                            sx={{
                                                flex: {
                                                    xs: '0 0 calc(100% / 2)',
                                                    sm: '0 0 calc(100% / 5)',
                                                },
                                                mr: 1,
                                            }}
                                            key={`related${index}`}
                                        >
                                            <Box sx={{ p: 1, height: 90, maxWidth: 113 }}>
                                                <Link to={item.url} target={'_blank'}>
                                                    <BrandedCertificateImage
                                                        src={gatewayUrl(item.imageCid)}
                                                        footerClassName={'footer-free-related-view'}
                                                        justify={'flex-end'}
                                                        footerText={
                                                            certificate.free ? (
                                                                <Trans
                                                                    i18nKey={`branding.${certificate.templateType}.footer`}
                                                                    components={[<strong />]}
                                                                />
                                                            ) : undefined
                                                        }
                                                        className=""
                                                    />
                                                </Link>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </>
                        )}
                    </Stack>
                </Box>
            )}
        </>
    );
}
